/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/share/:shareKey', {
      templateUrl: 'modules/app/shares/share.html',
      controller: 'ShareCtrl'
    });
  }]).
  /**
   * Share Page
   */
  controller('ShareCtrl', ['CardUtils', '$location', '$window', 'ShareKeyHelper', 'ShareUtils', 'Config', '$scope', function (CardUtils, $location, $window, ShareKeyHelper, ShareUtils, Config, $scope) {
    ShareUtils.getCard().then(function (card) {
      var view = $location.search().view;
      var cardPath = CardUtils.getCardUrl(card, true, view);
      $location.path(cardPath);
      $location.search("shareKey", ShareKeyHelper.getShareKey());
    }, function (response) {
      if (response.status === 403) {
        if (response.data.message.includes("SSO")) {
          var returnUrl = $window.location.href;
          var wsConfig = Config.get();
          var url = wsConfig.apiUrl + "/shares/by-share-key/" + ShareKeyHelper.getShareKey() + "/sso?returnUrl=" + encodeURIComponent(returnUrl);
          $window.location.href = url;
        }
        $scope.errorMessages = ["You don't have permission to view the share:", $location.absUrl()];
      } else if (response.status === 404 && !$scope.embedView) {
        $scope.errorMessages = ["The share link you're trying to view is invalid:", $location.absUrl(), "This can be caused when the person who shared it with you decides to delete it."];
      }
    });
  }]).controller('CreateShareCtrl', ['$scope', 'Api', '$http', 'CardRegistry', '$routeParams', '$location', 'Validation', 'UserRoles', 'User', 'Alerts', '$timeout', 'OrganizationSettings', '$rootScope', function ($scope, Api, $http, CardRegistry, $routeParams, $location, Validation, UserRoles, User, Alerts, $timeout, OrganizationSettings, $rootScope) {
    $scope.cardId = $scope.cardId || $routeParams.cardId;
    if (!$scope.hasCard) {
      $scope.card = CardRegistry.get($scope.cardId);
    }
    $scope.allowDebugPresets = UserRoles.isWatershedEmployee(User.get());
    var cronPresets = {};
    cronPresets.minutely = "0 * * ? * *";
    cronPresets.monthly = "0 0 0 1 * ?";
    cronPresets.weekly = "0 0 0 ? * MON";
    cronPresets.daily = "0 0 0 * * ?";
    cronPresets.weekdays = "0 0 0 ? * MON-FRI";
    cronPresets.disabled = undefined;
    $scope.alerts = [];
    $scope.selectedShare = null;
    $scope.shareCount = 0;
    $scope.shares = [];
    $scope.ssoSharingOnly = false;
    $scope.samlConfig = {};
    $scope.basePath = $location.absUrl().replace($location.url(), "");
    $scope.isAggregationCard = ['program', 'activity', 'interactions', 'person'].indexOf($scope.card.template.name) === -1;
    var getSAMLConfig = function getSAMLConfig() {
      $http.get(Api.url('/saml/configuration')).then(function (response) {
        $scope.samlConfig = response.data;
      });
    };
    $scope.getSharePath = function (basePath, shareKey) {
      return basePath + '/share/' + shareKey;
    };
    $scope.getTableauPath = function (basePath, shareKey) {
      return basePath.replace(/(index\.html)?#/, 'tableau.html') + '?shareKey=' + shareKey;
    };
    $scope.selectShare = function (idx) {
      $scope.selectedShare = $scope.selectedShare === idx ? null : idx;
      delete $scope.shareSaveMessage;
      delete $scope.shareSaveErrorMessage;
    };
    function loadShares() {
      $http.get(Api.url("/shares/by-card-id/" + $scope.cardId, true)).then(function (response) {
        $scope.shares = _.map(response.data.results, function (share) {
          share.snapshotTime = new Date(share.snapshotTime);
          if (!_.isUndefined(share.scheduledEmail)) {
            share.scheduledEmail.cronSchedule = _.invert(cronPresets)[share.scheduledEmail.cronSchedule];
            share.shareMethodIndex = 3;
          } else {
            // Set this so we have a default radio button selected
            // Must include all necessary workflow fields even if they are unused
            share.scheduledEmail = {
              cronSchedule: "disabled",
              actions: [{
                bodyIntro: "An update to the " + $scope.card.title + " report on Watershed LRS is available. View it by clicking on the following link:",
                subscribers: [],
                type: "EMAIL_REPORT"
              }],
              triggers: [],
              context: {}
            };
            share.shareMethodIndex = 0;
          }
          share.pendingChanges = false;
          return share;
        });
        $scope.shareCount = $scope.shares.length;
      });
    }
    $scope.createMode = true;
    $scope.cancelShare = function () {
      var pendingChangesMessage = "";
      _.each($scope.shares, function (share, index) {
        if (share.pendingChanges) {
          pendingChangesMessage += "\nShare " + (index + 1) + " has pending changes, are you sure you want to close?";
        }
      });
      if (pendingChangesMessage.length > 0) {
        if (window.confirm(pendingChangesMessage)) {
          $scope.createShareModal.dismiss('cancel');
        }
      } else {
        $scope.createShareModal.dismiss('cancel');
      }
      if ($scope.originalShareCount !== $scope.shareCount) {
        $rootScope.$broadcast("share-count-changed", $scope.shareCount);
      }
    };
    $scope.deleteShare = function (share) {
      $http['delete'](Api.url("/shares/" + share.id, true)).then(function () {
        loadShares();
      });
      $scope.alerts.push({
        text: "Share link " + share.key + " deleted successfully.",
        type: "success",
        timeout: 10000
      });
      $rootScope.$broadcast("app-delete-share");
    };
    $scope.createShare = function () {
      var shareConfig = {
        card: {
          id: $scope.cardId
        },
        realTime: true
      };
      shareConfig.snapshotTime = new Date();
      $http.post(Api.url("/shares/", true), shareConfig).then(function () {
        $scope.selectShare($scope.shares.length);
        loadShares();
        $scope.alerts.push({
          text: "Share created successfully.",
          type: "success",
          timeout: 10000
        });
        $rootScope.$broadcast("app-create-share");
      }, function () {
        $scope.alerts.push({
          text: "A share for card " + $scope.cardId + " could not be successfully created.",
          type: "danger",
          timeout: 10000
        });
      });
    };
    $scope.$on('$locationChangeStart', function () {
      $scope.cancelShare();
    });
    $scope.updateShareTime = function updateShareTime(share) {
      if (share.realTime) {
        share.snapshotTime = null;
      } else {
        share.snapshotTime = share.snapshotTime ? share.snapshotTime : new Date();
      }
      if (share.snapshotTime) {
        // Changed from 59 -> 58 because it was sporadically rounding the date up a whole day
        share.snapshotTime.setHours(23, 59, 58);
      }
      $timeout(function () {
        $scope.updateShare(share);
      });
    };
    $scope.addSubscriber = function addSubscriber(share) {
      share.errors = null;
      share.errors = Validation.validate({
        "to": {
          "rules": {
            "required": true,
            "multipleEmail": true
          },
          "value": share.newEmailAddress
        }
      });
      if (share.errors !== null) {
        return;
      }
      share.scheduledEmail.actions[0].subscribers.push({
        email: share.newEmailAddress
      });
      share.pendingChanges = true;
      delete share.newEmailAddress;
    };
    $scope.removeSubscriber = function addSubscriber(share, subscriber) {
      share.scheduledEmail.actions[0].subscribers = _.without(share.scheduledEmail.actions[0].subscribers, _.findWhere(share.scheduledEmail.actions[0].subscribers, subscriber));
      share.pendingChanges = true;
    };
    $scope.anyAreUnconfirmed = function anyAreUnconfirmed(share) {
      var unConfirmed = _.filter(share.scheduledEmail.actions[0].subscribers, function (s) {
        return s.accepted !== true;
      });
      return unConfirmed.length > 0;
    };
    $scope.updateShare = function updateShare(share, sendImmediateEmail) {
      share.scheduledEmail.actions[0].type = "EMAIL_REPORT";
      // Ensure these fields are defined for workflow
      share.scheduledEmail.context = {};
      share.scheduledEmail.triggers = [];
      var shareToUpdate = angular.copy(share);
      if (!_.isUndefined(share.scheduledEmail)) {
        // shareToUpdate.scheduledEmail.tasks[0] = JSON.stringify(shareToUpdate.scheduledEmail.tasks[0]);
        shareToUpdate.scheduledEmail.cronSchedule = cronPresets[shareToUpdate.scheduledEmail.cronSchedule];
      }
      var url = Api.url("/shares/" + shareToUpdate.id, true);
      if (sendImmediateEmail) {
        url += "?sendImmediateEmail=true";
      }
      $http.put(url, shareToUpdate).then(function (response) {
        if (sendImmediateEmail) {
          Alerts.raiseAlert({
            "type": "success",
            "text": "Test email was sent"
          });
        }
        if (share.scheduledEmail) {
          share.scheduledEmail = response.data.scheduledEmail;
          share.scheduledEmail.cronSchedule = _.invert(cronPresets)[share.scheduledEmail.cronSchedule];
        }
        $scope.shareSaveMessage = "Successfully saved";
        share.pendingChanges = false;
        // After 2 seconds, remove the success message
        $timeout(function () {
          delete $scope.shareSaveMessage;
        }, 2000);
      }, function (e) {
        $scope.shareSaveErrorMessage = "Save failed: " + e.data.exceptionMessage;
      });
    };

    //Email share
    $scope.emailShare = function (share, index) {
      $scope.currentShare = share;
      $scope.createMode = false;
      $scope.emailIndex = index + 1;
    };
    $scope.completedEmail = function (message, failed) {
      if (failed) {
        $scope.alerts.push({
          text: message,
          type: "danger",
          timeout: 10000
        });
      } else {
        $scope.alerts.push({
          text: message,
          type: "success",
          timeout: 10000
        });
      }
    };
    $scope.emails = "";
    $scope.note = "";
    $scope.sendEmail = function () {
      $scope.shareFormErrors = Validation.validate({
        "to": {
          "rules": {
            "required": true,
            "multipleEmail": true
          },
          "value": $scope.emails
        }
      });
      if ($scope.shareFormErrors !== null) {
        return;
      }
      var emails = _.map($scope.emails.split(","), function (email) {
        return email.trim();
      });
      var currShare = angular.copy($scope.currentShare);
      // currShare.scheduledEmail.tasks[0] = JSON.stringify(currShare.scheduledEmail.tasks[0]);

      $http.post(Api.url("/shares/email", true), {
        share: currShare,
        message: $scope.note,
        emails: emails
      }).then(function () {
        var end = emails.length > 1 ? "s." : ".";
        $scope.completedEmail("Email sent successfully to ".concat(emails.length, " recipient").concat(end));
        $scope.cancelEmail();
      }, function () {
        $scope.completedEmail("Sorry, we couldn't send an email right now. Please try again later.", true);
        $scope.cancelEmail();
      });
    };
    $scope.cancelEmail = function () {
      $scope.emails = "";
      $scope.note = "";
      $scope.createMode = true;
    };
    $scope.showRecipients = function showRecipients(share) {
      var subscriptionState = share.scheduledEmail.actions[0].subscriptionState;
      var msg = "";
      _.each(subscriptionState, function (value, key) {
        msg += key + " -> " + value + "\n";
      });
      window.alert(msg);
    };
    $scope.resendOptInEmails = function resendOptInEmails(share) {
      var subscriptionState = share.scheduledEmail.actions[0].subscriptionState;
      _.each(subscriptionState, function (value, key) {
        if (value === 'INVITED') {
          delete subscriptionState[key];
        }
      });
      $scope.updateShare(share, false);
    };
    $scope.showSsoShareOption = function () {
      return OrganizationSettings.hasFeature("ssoShares") && $scope.samlConfig.ssoServiceUrl;
    };
    loadShares();
    $scope.originalShareCount = $scope.shareCount;
    getSAMLConfig();
    OrganizationSettings.get().then(function (response) {
      $scope.ssoSharingOnly = response.ssoSharingOnly;
    });
  }]).directive('wsSelectOnClick', function () {
    return {
      restrict: 'A',
      link: function link(scope, element) {
        element.on('click', function () {
          this.select();
        });
        element.on('focus', function () {
          this.select();
        });
      }
    };
  }).directive('wsShareDatePicker', function () {
    return {
      restrict: 'A',
      scope: {
        share: "<",
        dateChanged: "="
      },
      templateUrl: "modules/app/shares/modals/share-date-input.html",
      link: function link(scope) {
        scope.open = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          scope.datePicker.opened = true;
        };
        scope.datePicker = {
          opened: false
        };
        scope.today = new Date();
      }
    };
  });
})();
